module.exports = __webpack_public_path__ + "assets/8d07ea90aa1148a04c759317fa3709b7.png";